import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import pagesConfigs from '../main/pages/pagesConfigs';
import productOwnerConfig from '../main/productOwner/productOwnerConfig';
import secureLocalStorage from 'react-secure-storage';
import FuseLayout from '@fuse/core/FuseLayout';

const publicRoutes = pagesConfigs.filter((config) =>
	['/login', '/forgot-password', '/reset-password', '/password/reset', '/404', '/500', '/otp', '/success'].some(
		(path) => config.routes.some((route) => route.path === path)
	)
);

const privateRoutes = [...pagesConfigs.filter((config) => !publicRoutes.includes(config)), ...productOwnerConfig];

const RootRedirect = () => {
	const role = JSON.parse(secureLocalStorage.getItem('user'))?.role[0];
	console.log('role', role);
	if (role === 'product_owner') {
		return <Navigate replace to="/productOwner" />;
	}
	return <Navigate replace to="/login" />;
};

// Root layout that will contain all authenticated routes
const RootLayout = () => {
	return (
		<FuseLayout>
			<Outlet />
		</FuseLayout>
	);
};

const routes = [
	// Public routes (no layout wrapper)
	...FuseUtils.generateRoutesFromConfigs(publicRoutes),

	// Private routes (with layout wrapper)
	{
		element: <RootLayout />,
		children: [
			...FuseUtils.generateRoutesFromConfigs(privateRoutes),
			// Root redirect
			{
				path: '/',
				element: <RootRedirect />,
			},
		],
	},
	// 404 route
	{
		path: '*',
		element: <Navigate replace to="/404" />,
	},
];

export default routes;
